import script from "./CompanyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyView.vue?vue&type=style&index=0&id=f6c940b6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6c940b6"]])

export default __exports__